import React from 'react';
import { Alert, Spin } from 'antd';
import PrioritySummaryCard from './PrioritySummaryCard';
import LifeCycleAnalyticsChartsAndPerformance, {
	LifeCycleAnalyticsChartsAndPerformanceProps,
} from './LifeCycleAnalyticsChartsAndPerformance';

type PrioritySummaryCardProps = React.ComponentProps<typeof PrioritySummaryCard>;

export type LifeCycleAnalyticsOverviewDashboardProps = {
	spinning: boolean;
	error: string;
	prioritySummaryProps: PrioritySummaryCardProps;
	chartsAndPerformanceProps: LifeCycleAnalyticsChartsAndPerformanceProps;
};

const LifeCycleAnalyticsOverviewDashboard = ({
	spinning,
	error,
	prioritySummaryProps,
	chartsAndPerformanceProps,
}: LifeCycleAnalyticsOverviewDashboardProps) => {
	return (
		<Spin spinning={spinning}>
			{error ? <Alert type="error" message={error} className="mb-4" /> : null}

			<PrioritySummaryCard {...prioritySummaryProps} />

			<LifeCycleAnalyticsChartsAndPerformance {...chartsAndPerformanceProps} />
		</Spin>
	);
};

export default LifeCycleAnalyticsOverviewDashboard;
